import { createAction } from '@reduxjs/toolkit';

export const shipmentNotesErrorAction = createAction('CHECKOUT_SHIPMENT_NOTES_ERROR');
export const deliveryCompletedAction = createAction('CHECKOUT_DELIVERY_COMPLETED');

type CompleteDeliveryStep = (payload: {
    isCustomQuoteSelected: boolean;
    shipmentNotes: string;
}) => ReturnType<typeof shipmentNotesErrorAction> | ReturnType<typeof deliveryCompletedAction>;
export const completeDeliveryStep: CompleteDeliveryStep = ({
    isCustomQuoteSelected,
    shipmentNotes,
}) => {
    if (isCustomQuoteSelected && !shipmentNotes) {
        return shipmentNotesErrorAction();
    } else {
        return deliveryCompletedAction();
    }
};
export const newQuotesRedirectBuyerAction = createAction<{
    prevDeliveryOptions: {
        serviceId: string | null;
    }[];
    newDeliveryOptions: {
        serviceId: string | null;
    }[];
}>('CHANGED_QUANTITY_UPDATE_DELIVERY');
